// component-asidePositioning.js
"use strict";
var FIX_TOP_CLASS = "fixTop";
var FIX_BOTTOM_CLASS = "fixBottom";
var OVERLAY_CLASS = "js-aside-overlay";
var OVERLAY_SELECTOR = "." + OVERLAY_CLASS;
var ASIDE_SELECTOR = ".js-mainContent .js-aside";
var ASIDE_TOGGLER = ".js-aside-menu-toggler";
var mainFunctionAside = function () {
    var aside = document.querySelector(ASIDE_SELECTOR);
    // Return inmediately if the main div or the aside are not present
    if (!aside)
        return;
    var mainContent = document.querySelector(".js-mainContent");
    var asideToggler = aside.querySelector(ASIDE_TOGGLER);
    if (mainContent && asideToggler) {
        window.addEventListener("scroll", function () {
            sidebarScroll(mainContent.getBoundingClientRect().top, mainContent.getBoundingClientRect().bottom - asideToggler.offsetHeight, aside);
        });
        sidebarScroll(mainContent.getBoundingClientRect().top, mainContent.getBoundingClientRect().bottom - asideToggler.offsetHeight, aside);
        asideToggler.addEventListener("click", function (e) {
            e.preventDefault();
            toggleAsideMenu();
        });
    }
};
/**
 * This to fix the sidebar menu to the left
 * within the main content wrapper boundaries
 * @param toolbarPosition
 * @param helpPosition
 * @param aside
 */
var sidebarScroll = function (topPosition, bottomPosition, aside) {
    if (topPosition > 0) {
        aside.classList.remove(FIX_TOP_CLASS, FIX_BOTTOM_CLASS);
    }
    else if (topPosition <= 0 && 0 <= bottomPosition) {
        aside.classList.add(FIX_TOP_CLASS);
        aside.classList.remove(FIX_BOTTOM_CLASS);
    }
    else if (0 > bottomPosition) {
        aside.classList.add(FIX_BOTTOM_CLASS);
        aside.classList.remove(FIX_TOP_CLASS);
    }
};
/**
 * This to add or remove the is-active class from the aside menu
 */
var toggleProductPageAsideMenu = function () { var _a; return (_a = document.querySelector(ASIDE_SELECTOR)) === null || _a === void 0 ? void 0 : _a.classList.toggle("is-active"); };
/**
 * This to slide in and out the aside menu
 */
var toggleAsideMenu = function () {
    var _a;
    // Toggle the aside menu
    toggleProductPageAsideMenu();
    var overLay = document.querySelector(OVERLAY_SELECTOR);
    // if there is an overlay
    if (overLay) {
        //remove it
        (_a = overLay === null || overLay === void 0 ? void 0 : overLay.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(overLay);
        return;
    }
    // Otherwise add it
    overLayHandler();
};
var overLayHandler = function () {
    // Create a div
    var el = document.createElement("div");
    // Add classes to the div
    el.setAttribute("class", "".concat(OVERLAY_CLASS, " aside-overlay animated fadeIn"));
    // Append the div to the body
    document.body.appendChild(el);
    // Add an event listener to it
    el.addEventListener("click", function () {
        var _a;
        // Toggle the menu
        toggleProductPageAsideMenu();
        // Remove itself
        (_a = el === null || el === void 0 ? void 0 : el.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(el);
    });
};
export default mainFunctionAside;
